import { gql } from '@/__generated__';
import { GetGateRendererDataQuery } from '@/__generated__/graphql';

export type GateDataForRenderer = GetGateRendererDataQuery['gate'];

export const GET_GATE_RENDERER_DATA = gql(`#graphql
  query GetGateRendererData($gateId: ID!) {
    gate(input: { id: $gateId }) {
      id
      mainDevice {
        id
      }
      movements2 {
        id
        activeMovement {
          ...GateMovementFragment
        }
        lastMovement {
          ...GateMovementFragment
        }
        lastKnownPosition {
          point
          source
          timestamp
        }
        lastBattery
        unit
        precision
        operatingState
      }
    }
  }
`);

export const GET_GATE_RENDERER_DATA_FOR_METRICS_VIEW = gql(`#graphql
  query GetGateRendererDataForMetricsView($viewId: ID!, $gateId: ID!) {
    metricsViewSection(id: $viewId) {
      id
      device(id: $gateId) {
        id
        gate {
          id
          mainDevice {
            id
          }
          movements2 {
            id
            activeMovement {
              ...GateMovementFragment
            }
            lastMovement {
              ...GateMovementFragment
            }
            lastKnownPosition {
              point
              source
              timestamp
            }
            unit
            precision
            operatingState
          }
        }
      }
    }
  }
`);
